import React from "react";
import { Grid, FormControl, TextField, Typography, MenuItem, Button } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Filter, SearchOffOutlined, SearchOutlined } from "@mui/icons-material";
import { FormControlLabel, Switch } from "@mui/material";

const DateRangePickerForInvoice = ({
    fromDate,
    toDate,
    onFromChange,
    onToChange,
    autoFocus = false,

    // 🔥 new props
    searchType,
    searchValue,
    onSearchTypeChange,
    onSearchValueChange,
    onSearchClick,

    containerProps = {},

    showSamePartyToggle = false,   // 🔥 NEW
    sameParty,                     // 🔥 NEW
    setSameParty,                  // 🔥 NEW
}) => {
    const dateFieldProps = {
        size: "small",
        variant: "standard",
        InputProps: {
            disableUnderline: true,
        },
        sx: {
            backgroundColor: "transparent",
            padding: 0,
            "& .MuiInputBase-root": {
                border: "none",
                paddingRight: "6px",
            },
            "& .MuiSvgIcon-root": {
                fontSize: "18px",
            },
        },
    };

    // map searchType to label
    const getSearchLabel = (type) => {
        switch (type) {
            case "DO No":
                return "Enter DO No";
            case "CO No":
                return "Enter CO No";
            case "Invoice No":
                return "Enter Invoice No";
            default:
                return "Enter Value";
        }
    };


    return (
        <Grid
            container
            padding="10px 5px 3px 10px"
            alignItems="center"
            sx={{ justifyContent: "flex-start" }}
            spacing={2}
            {...containerProps}
        >
            {/* From Date */}
            <Grid item xs={12} sm={3} md={2}>
                <FormControl fullWidth size="small">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            id="FromDate"
                            label='Invoice Date From'
                            value={dayjs(fromDate)}
                            onChange={onFromChange}
                            format="DD-MMM-YYYY"
                            autoFocus={autoFocus}
                            slotProps={{ textField: { ...dateFieldProps, variant: "outlined", color: "secondary" } }}
                        />
                    </LocalizationProvider>
                </FormControl>
            </Grid>

            {/* Dash */}
            <Grid item>
                <Typography fontWeight="bold">-</Typography>
            </Grid>

            {/* To Date */}
            <Grid item xs={12} sm={3} md={2}>
                <FormControl fullWidth size="small">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            id="ToDate"

                            label='Invoice Date To'
                            value={dayjs(toDate)}
                            onChange={onToChange}
                            format="DD-MMM-YYYY"
                            slotProps={{ textField: { ...dateFieldProps, variant: "outlined", color: "secondary" } }}
                        />
                    </LocalizationProvider>
                </FormControl>
            </Grid>

            {/* 🔥 Search Type Dropdown */}
            <Grid item xs={12} sm={3} md={2}>
                <FormControl fullWidth size="small">
                    <TextField
                        select
                        label="Search by"
                        value={searchType}
                        color="secondary"
                        onChange={onSearchTypeChange}
                        size="small"
                    >
                        <MenuItem value="DO No">DO No</MenuItem>
                        <MenuItem value="CO No">CO No</MenuItem>
                        <MenuItem value="Invoice No">Invoice No</MenuItem>
                    </TextField>
                </FormControl>
            </Grid>

            {/* 🔥 Search Value */}
            <Grid item xs={12} sm={3} md={2}>
                <FormControl fullWidth size="small">
                    <TextField
                        label={getSearchLabel(searchType)}  // 🔥 dynamic label here
                        value={searchValue}
                        color="secondary"
                        onChange={onSearchValueChange}
                        size="small"
                    />
                </FormControl>
            </Grid>


            {/* 🔥 Search Button */}
            <Grid item>
                <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    startIcon={<SearchOutlined />}
                    onClick={onSearchClick}

                >
                    Search
                </Button>
            </Grid>

            {showSamePartyToggle && (
                <Grid item sx={{ marginLeft: "auto" }}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={sameParty}
                                onChange={(e) => setSameParty(e.target.checked)}
                                color="secondary"
                            />
                        }
                        label="Same Party Conversion"
                    />
                </Grid>
            )}

        </Grid>
    );
};

export default DateRangePickerForInvoice;
